import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../ui/table";

const PLANET_ORDER = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"];

export default function PlanetaryPositions({ planets, ascendant, houses }) {
  if (!planets) return null;

  const getHouseNum = (planetName) => {
    if (!houses) return "-";
    for (const [hNum, hData] of Object.entries(houses)) {
      if (hData.planets?.some((p) => p.name === planetName)) return hNum;
    }
    return "-";
  };

  return (
    <div className="overflow-x-auto" data-testid="planetary-positions">
      <div className="mb-4 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20">
        <p className="text-sm text-amber-400 font-cinzel tracking-wide mb-1">Ascendant (Lagna)</p>
        <p className="text-slate-200 text-sm">
          <span className="font-semibold">{ascendant?.rashi?.name}</span>
          <span className="text-slate-400 ml-1">({ascendant?.rashi?.hindi})</span>
          <span className="font-data text-xs text-slate-400 ml-2">{ascendant?.degree_string}</span>
          <span className="text-slate-400 mx-1">|</span>
          <span className="text-violet-400 text-xs">{ascendant?.nakshatra?.name} P{ascendant?.nakshatra?.pada}</span>
        </p>
      </div>

      <Table>
        <TableHeader>
          <TableRow className="border-white/10 hover:bg-transparent">
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider">Planet</TableHead>
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider">Sign</TableHead>
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider">Degree</TableHead>
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider hidden sm:table-cell">Nakshatra</TableHead>
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider hidden md:table-cell">House</TableHead>
            <TableHead className="text-amber-400 font-cinzel text-xs tracking-wider">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {PLANET_ORDER.map((name) => {
            const p = planets[name];
            if (!p) return null;
            return (
              <TableRow key={name} className="border-white/5 hover:bg-white/5 transition-colors"
                data-testid={`planet-row-${name.toLowerCase()}`}>
                <TableCell className="font-semibold text-slate-100 text-sm">{name}</TableCell>
                <TableCell className="text-sm">
                  <span className="text-slate-200">{p.rashi.name}</span>
                  <span className="text-slate-500 text-xs ml-1">({p.rashi.hindi})</span>
                </TableCell>
                <TableCell className="font-data text-xs text-slate-300">{p.degree_string}</TableCell>
                <TableCell className="text-xs text-violet-300 hidden sm:table-cell">
                  {p.nakshatra.name} <span className="text-slate-500">P{p.nakshatra.pada}</span>
                </TableCell>
                <TableCell className="font-data text-sm text-slate-300 hidden md:table-cell">
                  {getHouseNum(name)}
                </TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {p.is_retrograde && <span className="text-red-400 text-[10px] font-bold px-1 py-0.5 bg-red-500/10 rounded" data-testid={`status-retro-${name.toLowerCase()}`}>R</span>}
                    {p.is_exalted && <span className="text-emerald-400 text-[10px] font-bold px-1 py-0.5 bg-emerald-500/10 rounded">Exlt</span>}
                    {p.is_debilitated && <span className="text-orange-400 text-[10px] font-bold px-1 py-0.5 bg-orange-500/10 rounded">Deb</span>}
                    {p.is_combust && <span className="text-yellow-400 text-[10px] font-bold px-1 py-0.5 bg-yellow-500/10 rounded">Cmb</span>}
                    {p.is_vargottama && <span className="text-blue-400 text-[10px] font-bold px-1 py-0.5 bg-blue-500/10 rounded">Var</span>}
                    {!p.is_retrograde && !p.is_exalted && !p.is_debilitated && !p.is_combust && !p.is_vargottama && (
                      <span className="text-slate-600 text-xs">-</span>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
